import { IListItemWithKmlUrl } from "../../schemas/IListItemWithKmlUrl";

export const getOption = (optionNumber: string, options?: IListItemWithKmlUrl[]) =>
  options?.find((option) => option.itemNumber === optionNumber);
